import { FC } from 'react';

import { NEXT_ACTION_TEXTS } from '@/consts/actions';

import { formatDate } from '@/helpers/formatDate';

interface IDateCellNextAction {
  action: number;
  date: string;
}

const DateCellNextAction: FC<IDateCellNextAction> = ({ action, date }) => {
  const actionText = NEXT_ACTION_TEXTS[action] || '';

  return (
    <div className="flex items-center gap-3">
      {formatDate(date)}
      <br />
      {actionText}
    </div>
  );
};

export default DateCellNextAction;
